


export const onRouteUpdate = ({ location }) => {
  if (!location || !location.hash) return;

  const scrollToHash = () => {
    const el = document.querySelector(location.hash);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
      let retries = 10;
      const interval = setInterval(() => {
        const target = document.querySelector(location.hash);
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
          clearInterval(interval);
        } else if (--retries <= 0) {
          clearInterval(interval);
          console.warn(`Element not found for hash: ${location.hash}`);
        }
      }, 100);
    }
  };

  requestAnimationFrame(() => {
    setTimeout(scrollToHash, 100); // delay allows time for DOM content to load
  });
};
